<template>
	<div
	@click="clickFunc"
	>
    <div
        class="info-box"
    >
        <div class="info-part">
            <div>
                <span class="title-span">{{islandname}}</span>
            </div>
			
            <div>
                <span tkey="主辦方" class="content-span">{{i18n.tkey("lang_sponsor")}}:&nbsp;</span>
                <span class="content-span">{{companyname}}</span>
            </div>
					
        </div>

        <div class="icon-part">
            &nbsp;
            <span v-show="currTag">
                <font-awesome-icon icon="fa-solid fa-flag" style="color: #ff0000;" />
            </span>
        </div>
		
    </div>
	<div style="position: relative;width:100%;padding-top: 50%;">
		<img src="@/assets/selectland.gif" class="zoom-img" onerror="this.error = null">
	</div>
	</div>
</template>

<script setup>

import {inject, toRef, computed} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFlag } from '@fortawesome/free-solid-svg-icons'

library.add(faFlag)

const props = defineProps(["obj"])
const emits = defineEmits(["clickOption"])

const userInfoRef = toRef(useUserinfo())

const i18n = inject("i18n")

const companyname = computed(() => {
    let name = props.obj.companyname2

    if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(props.obj.companyname2)){
        name = props.obj.companyname
    }

    if (props.obj.companycode == "ZZ"){
        name = "3DShopopee"
    }

    return name
})

const islandname = computed(() => {
    let name = props.obj.addinfo6

    if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(name)){
        name = props.obj.recordname
    }

    return name
})

const currTag = computed(() => {
    let tag = false

    if (null != userInfoRef.value.islandID){
        tag = props.obj.id == userInfoRef.value.islandID
    }else{
        tag = props.obj.companycode == "ZZ"
    }

    return tag
})

function clickFunc(){
    // if (!currTag.value){
        emits("clickOption", props.obj)
    // }
}

</script>

<style scoped>
.info-box {
    display: flex;
    box-sizing: border-box;
    padding: 10px;
    text-align: left;
    justify-content: space-between;
    align-items: center;
	background-color:#6a84b3;
}

.icon-part {
    width: 50px;
    font-size: 24px;
}

.info-part {
    width: calc(100% - 50px);
}

.title-span {
    color: #efefef;
    font-weight: 600;
}
.content-span{
	color: #eeeeee;
}

.selected-bg {
    background: #ecf5ff;
}
.zoom-img{
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	position: absolute;
}

.zoom-img:hover {
  transform: scale(1.2);
}

</style>